lazyload();
function lazyload() {
  const imgs = document.querySelectorAll("img");
  // console.log(imgs);

  if (!imgs) return;

  // Set up intersection observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const intersecting = entry.isIntersecting;
      if (!intersecting) return;

      entry.target.addEventListener(
        "load",
        () => {
          entry.target.classList.remove("lazyload");
          entry.target.classList.add("lazyloaded");
        },
        { once: true }
      );
    });
  });

  // Set up resizeobserver
  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const width = entry.target.offsetWidth;
      entry.target.sizes = `${width}px`;
    }
  });

  for (const img of imgs) {
    // observer.observe(img);
    resizeObserver.observe(img);
  }
}
